import { isBrowser } from '../utils';
import { TrackingMiddleware } from '../types';

type DataLayerEvent = {
  event: string;
  [key: string]: string;
};

type DataLayerNode = { [k: string]: string | boolean };

declare global {
  interface Window {
    dataLayer: DataLayerNode[];
  }
}

const pushToDataLayer = (data: DataLayerEvent) => {
  if (isBrowser()) {
    // Provide empty array to push into to avoid errors in development
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
};

const sendToGA: TrackingMiddleware = () => async event => {
  pushToDataLayer({
    ...event.data,
    ...event._deprecatedBuildProprtiesInRoot(),
    _data: event.data,
    _context: event.context,
    event: 'analyticsEvent',
    eventLabel: event.name,
  });
};

export default sendToGA;
